/*
 * @Author: Chao Yang
 * @Date: 2020-07-22 03:25:24
 * @LastEditor: Chao Yang
 * @LastEditTime: 2022-08-25 12:56:47
 */
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { BaseProxy } from '../base.proxy';
import { format } from 'date-fns';
import { IDataRange } from '../../model/common/iDataRange.model';
import * as IDtoAccountGroup from 'src/app/domain/model/account-group/index';
import { IAccount2023, IAccountBalance2023 } from '../../model/dashboard';
import { environment } from 'src/environments/environment';

@Injectable()
export class DashboardProxy extends BaseProxy {
  aggregateVisible(
    accounts: IDtoAccountGroup.IAccountItem[],
    viewDataForAllInvestors: boolean
  ): Observable<boolean> {
    if (environment.feature.newApi === false) {
      return this._http.post<boolean>(
        `/ip/api/dashboard/aggregate/visible?viewDataForAllInvestors=${viewDataForAllInvestors}`,
        accounts
      );
    }else{
      return this._http.post<boolean>(
        `/ip-api/api/dashboard/aggregate/visible?viewDataForAllInvestors=${viewDataForAllInvestors}`,
        accounts
      );
    }
  }

  GetLayout(name: string) {
    if (environment.feature.newApi === false) {
      return this._http.get<any[]>(`/ip/api/dashboard/layout?name=${name}`);
    } else {
      return this._http.get<any[]>(`/ip-api/api/layout?name=${name}`);
    }
  }

  GetUserDateRange(
    start: Date,
    end: Date,
    displayclosedaccounts: boolean,
    accounts: IDtoAccountGroup.IAccountItem[]
  ) {
    var startStr = format(start, 'yyyy-MM-dd'),
      endStr = format(end, 'yyyy-MM-dd');
    return this._http.post<IDataRange>(
      `/ip/api/dashboard/daterange?start=${startStr}&end=${endStr}&displayclosedaccounts=${displayclosedaccounts}`,
      accounts
    );
  }

  GetUserCurrencies(viewDataForAllInvestors: boolean) {
    if (environment.feature.newApi === false) {
      return this._http.get<string[]>(
        `/ip/api/dashboard/currencies?viewDataForAllInvestors=${viewDataForAllInvestors}`
      );
    } else {
      return this._http.get<string[]>(
        `/ip-api/api/dashboard/currencies?viewDataForAllInvestors=${viewDataForAllInvestors}`
      );
    }
  }

  getAccountBalances2023(
    start: Date,
    end: Date,
    accounts: IDtoAccountGroup.IAccountItem[],
    viewDataForAllInvestors: boolean
  ) {
    var startStr = this.getDateStr(start),
      endStr = this.getDateStr(end);
    return this._http
      .post<IAccountBalance2023>(
        `/ip/api/dashboard/myinvestments/balances/2023?start=${startStr}&end=${endStr}&viewDataForAllInvestors=${viewDataForAllInvestors}`,
        accounts
      )
      .pipe(
        map((item) => {
          if (item.layout.lastModificationTimeDataLayout) {
            item.layout.lastModificationTimeDataLayout = new Date(
              item.layout.lastModificationTimeDataLayout
            );
          }

          if (item.layout.lastModificationTimeDocumentLayout) {
            item.layout.lastModificationTimeDocumentLayout = new Date(
              item.layout.lastModificationTimeDocumentLayout
            );
          }
          return item;
        })
      );
  }

  updateMyInvestmentsLayout(layoutUpdateDto: {
    dataLayout: string;
    documentsOnlyLayout: string;
    fundId: number[];
  }) {
    return this._http.put<any>(
      `/ip/api/dashboard/myinvestments/layout`,
      layoutUpdateDto
    );
  }
}
